import { render } from "./GUI.vue?vue&type=template&id=4f5f668a"
import script from "./GUI.vue?vue&type=script&lang=ts"
export * from "./GUI.vue?vue&type=script&lang=ts"

import "./GUI.vue?vue&type=style&index=0&id=4f5f668a&lang=scss"
script.render = render

export default script